import { Repeat } from "lucide-react";

const DURATIONS = [10, 15, 20, 30, 45, 60, 120, 180, 240, 300];
const NATIVE = ["none", "lip_sync", "auto", "native"];

// Map a previous video's saved settings onto Create page state
export const settingsToForm = (s) => {
  const form = {};
  if (["fast", "premium"].includes(s.video_mode)) form.videoMode = s.video_mode;
  if (s.video_model) form.videoModel = s.video_model;
  if (s.quality_tier) form.qualityTier = s.quality_tier;
  if (s.aspect_ratio) form.aspectRatio = s.aspect_ratio;
  if (s.premium_type) form.premiumType = s.premium_type;
  if (s.duration) {
    const d = DURATIONS.reduce((a, b) => (Math.abs(b - s.duration) < Math.abs(a - s.duration) ? b : a));
    form.videoDuration = String(d);
  }
  if (s.use_native_audio === true) form.presentationStyle = "talking_head";
  const v = s.voice_option;
  if (v === "visuals-only") return { form, voiceMode: "none", voiceId: null };
  if (!v || NATIVE.includes(v)) return { form, voiceMode: "auto", voiceId: null };
  return { form, voiceMode: "voiceover", voiceId: v };
};

const label = (f) => [
  f.videoMode === "premium" ? "Premium" : f.videoMode === "fast" ? "Fast" : null,
  f.videoMode === "fast" && f.videoModel ? (f.videoModel === "kling" ? "Kling" : "H3 Turbo") : null,
  f.aspectRatio,
  f.videoDuration && f.videoDuration !== "auto" ? `${f.videoDuration}s` : null,
].filter(Boolean).join(" · ");

export const SameSettingsNote = ({ settings, form }) => {
  const inherited = settingsToForm(settings).form;
  const changed = Object.keys(inherited).some((k) => inherited[k] !== form[k]);
  return (
    <div data-testid="same-settings-note"
      className="flex items-start gap-2 rounded-lg border border-[#00F0FF]/30 bg-[#00F0FF]/5 px-3 py-2 text-sm">
      <Repeat className="mt-0.5 h-4 w-4 shrink-0 text-[#00F0FF]" />
      <p className="text-muted-foreground">
        <span data-testid="same-settings-title" className="font-medium text-white">
          {changed ? "Changed from last episode" : "Same as last episode"}
        </span>
        {label(form) && <span data-testid="same-settings-summary"> - {label(form)}</span>}
        . Voice, quality and length were copied from the last episode; you can still change them below.
      </p>
    </div>
  );
};
